import { render, staticRenderFns } from "./ContractType.vue?vue&type=template&id=40afb9df&scoped=true&"
import script from "./ContractType.vue?vue&type=script&lang=js&"
export * from "./ContractType.vue?vue&type=script&lang=js&"
import style0 from "./ContractType.vue?vue&type=style&index=0&id=40afb9df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40afb9df",
  null
  
)

export default component.exports